import { bool, string } from 'prop-types';
import React, { useRef } from 'react';

import HoverDetails from '../../generic/HoverDetails';
import IconLink from '../../generic/IconLink';
import { associatedBrandShape } from '../../prop-types';

function BrandLink({ model, showIcon, className, ...rest }) {
  const { name, id, code, shopStatus, cluster } = model;
  const linkRef = useRef(null);

  return (
    <>
      <span ref={linkRef}>
        <IconLink
          className="brand_link"
          to={`/brands/${id}/show`}
          showIcon={showIcon}
          {...rest}
        >
          <span className="brand_link__text">{name}</span>
        </IconLink>
      </span>
      <HoverDetails
        size="small"
        className={className}
        linkRef={linkRef}
        title={name}
        fields={{
          Code: code,
          Status: shopStatus,
          Cluster: cluster,
        }}
      />
    </>
  );
}

BrandLink.propTypes = {
  model: associatedBrandShape.isRequired,
  className: string,
  showIcon: bool,
};

BrandLink.defaultProps = {
  showIcon: false,
  className: '',
};

export default BrandLink;
